
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../GardenPopup/DeletePopup'
import { useAuthState } from '../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { MainFeederLocationDataDDL } from '../../../../../Components/CommonDDL/MainFeederLocationDataDDL'
import { PreventiveMaintainanceWorkDeleteAPI, PreventiveMaintainanceWorkTableDataAPI, PreventiveMaintainanceWorkTableExportDataAPI } from '../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveMaintainanceWork/PreventiveMaintainanceWorkSlice'
import { Loading } from '../../../../../Helper/Loading'
import ViewURL from '../../../../../Components/ViewURL/ViewURL'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { CommonWaterSupplyPreventiveMaintainanceWorkExportData } from './CommonWaterSupplyPreventiveMaintainanceWorkExportPage'
import { TableNote } from '../../../../../Components/Note/Note'
import { WaterSupplyLocationDataDDL } from '../../../../../Components/CommonDDL/WaterSupplyLocationDataDDL'
import { DistributionLineLocationDataDDL } from '../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { toastErrorr } from '../../../../../Helper/ToastMessage'
import { TableDeleteNote } from '../../../../../Components/Note/TableDeleteNote'

export default function CommonWaterSupplyPreventiveMaintainanceWorkPage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')
    let M_Distri_WorkTypeID = searchParams.get('M_Distri_WorkTypeID')

    // console.log(WLable)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [Heading, setHeading] = useState('')
    const [WaterQualityPhPopupShow, setWaterQualityPhPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [WaterQualityChlorinePopupShow, setWaterQualityChlorinePopupShow] = useState()

    const [PDFUrl, setPDFUrl] = useState('')


    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: HWard && HWard ? HWard : '0',
    //     Label: WLable && WLable ? WLable : "Select...",
    // })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: RoleID == '16' ? 0 : HWard && HWard ? HWard : '0',
        Label: RoleID == '16' ? "Select..." : WLable && WLable ? WLable : "Select...",
    })

    // console.log(WardName.Label)

    // const [MainFeederLocationDDL, setMainFeederLocationDDL] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WaterSupplyLocationDDL, setWaterSupplyLocationDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? moment(date).endOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))

    const handleEditOnClick = (item) => {
        setWaterQualityChlorinePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterQualityChlorinePopupShow(false)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: RoleID == '16' ? 0 : HWard,
            Label: RoleID == '16' ? 'Select...' : WLable,
        })
        // setMainFeederLocationDDL({
        //     ...MainFeederLocationDDL,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setWaterSupplyLocationDDL({
            ...WaterSupplyLocationDDL,
            ID: 0,
            Label: 'Select...',
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    const handleGetPDFUrl = (pdfUrl) => {
        if (pdfUrl && pdfUrl != '') {
            setPDFUrl(pdfUrl)
        } else {
            toastErrorr("PDF not found")
        }
    }

    const handleOpenPdf = () => {
        window.open(PDFUrl)
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }
    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            // M_WardID: WardName.ID,
            M_WardID: WardName.ID,
            // M_WS_LocationID: MainFeederLocationDDL.ID,
            M_WS_LocationID: DashProjectTypeId == "1" ? WaterSupplyLocationDDL.ID : JunctionNameDDL.ID,
            M_WS_WorkTypeID: M_Distri_WorkTypeID,
            M_WS_WorkPeriodID: 0,
            M_UserID: UserID,
            Flag: ApiFlag,
            token: token,
            From: From,
            To: To,
            DashProjectTypeId: DashProjectTypeId,
            handleGetPDFUrl: handleGetPDFUrl,
            RoleID: RoleID,
            handleMaintainanceWorkExport: handleMaintainanceWorkExport
        }
        // if (WardName.ID != "0") {
        dispatch(PreventiveMaintainanceWorkTableDataAPI({ data }))
        // }

    }, [IsPost, To, isSearch, IsClear, WardName.ID])

    const { tableData, isLoading } = useSelector(state => state.PreventiveMaintainanceWorkTableData)


    const handleMaintainanceWorkExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            // M_WardID: WardName.ID,
            M_WardID: WardName.ID,
            M_WS_LocationID: DashProjectTypeId == "1" ? WaterSupplyLocationDDL.ID : JunctionNameDDL.ID,
            M_WS_WorkTypeID: M_Distri_WorkTypeID,
            M_WS_WorkPeriodID: 0,
            M_UserID: UserID,
            Flag: ApiFlag,
            token: token,
            From: '1',
            To: '99999',
            DashProjectTypeId: DashProjectTypeId,
            handleGetPDFUrl: handleGetPDFUrl,
            RoleID: RoleID
        }
        // if (WardName.ID != "0") {
        dispatch(PreventiveMaintainanceWorkTableExportDataAPI({ data }))
        // }

    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.PreventiveMaintainanceWorkTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WS_MaintenanceServicesID: item.t_wS_MaintenanceServicesID,
            T_Distri_WaterMaintenanceServicesID: item.t_Distri_WaterMaintenanceServicesID,
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            handleIsPost: handleIsPost,
            RoleID: RoleID
        }
        dispatch(PreventiveMaintainanceWorkDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.PreventiveMaintainanceWorkDeleteData)

    // console.log('date', moment().format('DD-MM-YYYY'), tableData)
    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-9'>
                                <h5 className="mt-2">{searchName}</h5>
                            </div>
                            <div className='col-3 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <CommonWaterSupplyPreventiveMaintainanceWorkExportData
                                                ExcelData={ExportTableData}
                                                RoleID={RoleID}
                                                FromDate={FromDate}
                                                ToDate={ToDate}
                                                name={searchName}
                                            // searchName={searchName}
                                            />
                                    }
                                    {
                                        tableData && tableData.table && tableData.table.length > 0 ?
                                            <button type="button" className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                                onClick={handleOpenPdf}
                                            ><i className='fas fa-file-pdf mx-1'></i>PDF</button>
                                            :
                                            <></>
                                    }
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-2 col-md-6">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />

                                                </div>

                                            </div>
                                            <div className="col-lg-2 col-md-6">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-6">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // M_WardID={M_WardID}
                                                // Flag='ward'
                                                />
                                            </div>

                                            {/* <div className="col-lg-3 col-md-6">
                                                <MainFeederLocationDataDDL
                                                    MainFeederLocationDDL={MainFeederLocationDDL}
                                                    setMainFeederLocationDDL={setMainFeederLocationDDL}
                                                    WardName={WardName}
                                                // Flag='ward'
                                                />
                                            </div> */}

                                            {/* {
                                                DashProjectTypeId == '1' ?
                                                    <div className="col-lg-3 col-md-6">
                                                        <WaterSupplyLocationDataDDL
                                                            WaterSupplyLocationDDL={WaterSupplyLocationDDL}
                                                            setWaterSupplyLocationDDL={setWaterSupplyLocationDDL}
                                                            WardName={WardName.ID}
                                                        // Flag='ward'
                                                        />
                                                    </div>
                                                    :
                                                    <div className="col-lg-3 col-md-6">
                                                        <DistributionLineLocationDataDDL
                                                            DistributionLineLocationDDL={JunctionNameDDL}
                                                            setDistributionLineLocationDDL={setJunctionNameDDL}
                                                            WardName={WardName.ID}
                                                        // Flag='ward'
                                                        />
                                                    </div>
                                            } */}

                                            {
                                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                                    <div className="col-lg-3 col-md-6">
                                                        <DistributionLineLocationDataDDL
                                                            DistributionLineLocationDDL={JunctionNameDDL}
                                                            setDistributionLineLocationDDL={setJunctionNameDDL}
                                                            WardName={WardName}
                                                        // Flag='ward'
                                                        />
                                                    </div> :

                                                    <div className="col-lg-3 col-md-6">
                                                        <WaterSupplyLocationDataDDL
                                                            WaterSupplyLocationDDL={WaterSupplyLocationDDL}
                                                            setWaterSupplyLocationDDL={setWaterSupplyLocationDDL}
                                                            WardName={WardName}
                                                        // Flag='ward'
                                                        />
                                                    </div>

                                            }

                                            <div className="col-12 col-md-6 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>

                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive">
                                            <TableDeleteNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        <th>Location</th>
                                                        <th>Work Name</th>
                                                        <th>Before Image</th>
                                                        <th>After Image</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td style={{ whiteSpace: 'nowrap' }}>{item.workAssingDate ? item.workAssingDate : '-'}</td>
                                                                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                                <td>{item.workName ? item.workName : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        (item.beforePhoto == null) ?
                                                                            <span>-</span>
                                                                            :
                                                                            <>
                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                    onClick={() => handleShowImage(item.beforePhoto, 'Photo')}
                                                                                ></i>
                                                                            </>
                                                                    }
                                                                </td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        (item.afterPhoto == null) ?
                                                                            <span>-</span>
                                                                            :
                                                                            <>
                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                    onClick={() => handleShowImage(item.afterPhoto, 'Photo')}
                                                                                ></i>
                                                                            </>
                                                                    }
                                                                </td>
                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    {
                                                                        ((item.workAssingDate) == moment().format('DD/MM/YYYY')) ?
                                                                            <div style={{ textAlign: "center", marginLeft: "-1.2em" }}>
                                                                                {/* <span> */}
                                                                                <DeletePopup
                                                                                    open={DeletePopupShow}
                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                    item={item}
                                                                                />
                                                                                {/* </span> */}
                                                                            </div>
                                                                            : '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {
                ShowImagePopup &&
                <ViewURL
                    Heading={Heading}
                    ImagePopUpData={ImagePopUpData}
                    setshowImagePopup={setshowImagePopup}
                />
            }
        </div>



    )
}